import { User } from '@sentry/browser';
import { Company, Label, Location, Maintenance, PagedResult } from '..';
import { Expense } from '../expenses';

export enum ProductServiceValueType {
    fixed = 'fixed',
    hour = 'hour',
    kilometer = 'kilometer'
  }

export interface Quotation {
  id?: string;
  name?: string;
  identifier?: string;
  updatedAt?: string;
  createdAt?: string;
  approvedAt?: string;
  refusedAt?: string;
  approvedBy?: User;
  refusedBy?: User;
  expenses?: QuotationExpense[];
  expiredAt?: string;
  status?: string;
  description?: string;
  subTotal?: number;
  total?: number;
  location: Location;
  approvedMessage?: string;
  additionalInformation?: string;
  maintenance?: Maintenance;
  company?: Company;
  discount: QuotationDiscount;
  items?: QuotationItem[];
  labels?: Label[];
  productsCount?: number;
  servicesCount?: number;
  productsValueTotal?: number;
  servicesValueTotal?: number;
  expensesValueTotal?: number;
  attachments: QuotationAttachments[];
  updatedByName?: string;
  updatedByClientApplicationName?: 'mountdoom' | 'grond';
}

export interface QuotationExpense {
  id?: string;
  quotation?: Quotation;
  expense?: Expense;
  value?: number;
  path?: string;
  description?: string;
  createdAt?: string;
}
export interface  QuotationAttachmentsResponse {
  id?: string;
  attachments: QuotationAttachments[];
}

export interface QuotationAttachments {
  id?: string;
  quotation_id?: string;
  account_id?: number;
  title?: string;
  type?: string;
  archived?: boolean;
  position?: number;
  path?: string;
  createdAt?: string;
}

export interface ExecuteActionQuotationInput {
  id: string;
  updatedAt: string;
  approvedMessage: string | null;
}

export interface QuotationLabelInput {
  labelId: string;
  quotationId: string;
}

export interface QuotationDiscount {
  type?: 'percent' | 'value';
  value?: number;
  total?: number;
}

export interface QuotationItem {
  id?: string;
  description?: string;
  quantity?: number;
  productServiceValue?: number;
  total?: number;
  productService?: ProductService;
}

export interface ProductService {
  id?: string;
  name?: string;
  imageUrl?: string;
  type?: 'product' | 'service';
  measure?: 'units' | 'centimeters' | 'meters' | 'liters' | 'milliliters' | 'kilogram' | null;
  archived?: boolean;
  productServiceCompanies?: ProductServiceCompanies[];
  value?: number;
  description?: string;
}

export interface ProductServiceCompanies {
  company: Company;
  value: number;
  valueType: ProductServiceValueType;
  archived: boolean;
  preferences?: ProductServiceCompanyPreferences;
}

export interface ProductServiceCompanyPreferences {
  allowEditValue: boolean;
  weekDayValues?: {
    monday: number
    tuesday: number
    wednesday: number
    thursday: number
    friday: number
    saturday: number
    sunday: number
  };
}

export interface ListQuotationsQueryResponse {
  quotations: PagedResult<Quotation>;
}

export interface GetQuotationQueryResponse {
  quotation: Quotation;
}

export interface GetQuotationAttachmentsQueryResponse {
  quotation: QuotationAttachmentsResponse;
}

export interface ListQuotationsResult {
  items: Quotation[];
  totalCount: number;
  filtered: boolean;
}

export interface DialogProductServiceData {
  productService: ProductService;
  isViewMode: boolean;
}
